import gql from 'graphql-tag';

export const GET_LOGGED_OUT_RECOMMENDATIONS = gql`
  query GetLoggedOutRecommendations(
    $jobId: ID!
    $limit: Int
    $zone: Zone!
    $visitorId: UUID!
    $timezone: Timezone
    $locale: Locale
  ) {
    loggedOutRecommendedJobs(
      jobId: $jobId
      limit: $limit
      source: LOGGED_OUT_HOME
      zone: $zone
      visitorId: $visitorId
      platform: WEB
    ) {
      globalJobs {
        solMetadata
        job {
          advertiser {
            name(locale: $locale)
          }
          id
          title
          location {
            label(locale: $locale)
          }
          listedAt {
            shortLabel(timezone: $timezone, locale: $locale)
          }
          products {
            branding {
              logo {
                url
              }
            }
          }
        }
      }
      solMetadata
    }
  }
`;
